import { APIService } from "@/config/api-service-client.js";

const PATH = `/audit`;

const getDefaultState = () => {
  return {
    auditList: {
      content: [],
      pagination: null,
    },
    auditListParams: {
      pagination: {
        pageSize: 10,
        currentPage: 1,
      },
      action: null,
      atuIdFilter: null,
      searchText: "",
      tableSorting: {
        sortType: "",
        sortTypeOrder: "",
      },
    },
  };
};

export default {
  state: getDefaultState(),
  mutations: {
    RESET_AUDIT_STATE(state) {
      Object.assign(state, getDefaultState());
    },
    MUTATE_AUDIT(state, val) {
      const { content, ...rest } = val;
      state.auditList.content = content;
      state.auditList.pagination = rest;
    },
  },
  actions: {
    async fetchAudit(ctx) {
      const params = ctx.state.auditListParams;
      const sortType = params.tableSorting.sortType;
      const sortTypeOrder = params.tableSorting.sortTypeOrder;
      const page = params.pagination.currentPage - 1;
      const size = params.pagination.pageSize;
      const searchText = params.searchText;

      let path = `${PATH}?sort=${sortType},${sortTypeOrder}&page=${page}&size=${size}`;

      if (searchText) {
        path = `${path}&key=${searchText}`;
      }

      const action = params.action
        ?.map((el, i) => {
          if (el) {
            if (i === 0) {
              return `&action=${el}`;
            } else {
              return `action=${el}`;
            }
          }
        })
        .join("&");
      if (action && action.length > 0) {
        path = `${path}${action}`;
      }

      const atu_id = params.atuIdFilter
        ?.map((el, i) => {
          if (el) {
            if (i === 0) {
              return `&atu_id=${el}`;
            } else {
              return `atu_id=${el}`;
            }
          }
        })
        .join("&");
      if (atu_id && atu_id.length > 0) {
        path = `${path}${atu_id}`;
      }

      try {
        const resp = await APIService.get(path);
        ctx.commit("MUTATE_AUDIT", resp);
        return resp;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
  },
  getters: {
    getAuditList: (state) => state.auditList,
  },
};
